<!-- SMT微信公众号弹框 -->
<template>
  <el-dialog
    width="560px"
    top="7%"
    title="绑定微信公众号"
    custom-class="offiaccount-dialog"
    append-to-body
    :visible="isShow"
    :lock-scroll="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="handleClose"
  >
    <div class="offiaccount-dialog__content">
      <p class="offiaccount-dialog__content__title">
        绑定微信公众号，第一时间了解订单的最新进度
      </p>
      <p class="offiaccount-dialog__content__desc">
        包含支付信息，样品图确认，EQ确认，自供料寄出提醒，发货物流信息等
      </p>
      <p class="offiaccount-dialog__content__tips">
        当前扫码仅推送订单消息，后续或用于账号登录
      </p>
      <template v-if="smtOffiaccountInfo && smtOffiaccountInfo.url">
        <img 
          class="offiaccount-dialog__content__img" 
          :src="smtOffiaccountInfo.url" 
          alt="华秋SMT公众号" 
        />
        <div class="offiaccount-dialog__content__alert">
          <span>注意：</span>
          <p>以上公众号二维码扫描后，微信公众号将自动与华秋ID进行绑定二维码请勿随便转发，避免订单信息泄露</p>
        </div>
        <p class="offiaccount-dialog__content__time">
          生成时间：{{ smtOffiaccountInfo.createTime }}
        </p>
        <p class="offiaccount-dialog__content__time">
          有效期至：{{ smtOffiaccountInfo.expireTime }}
        </p>
      </template>
      <img 
        v-else
        class="offiaccount-dialog__content__img" 
        src="@@/assets/img/smt/smt_offiaccount.png" 
        alt="华秋SMT公众号" 
      />
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
  },
  data() {
    return {
      isShow: false,
    }
  },
  computed: {
    // SMT微信公众号信息
    ...mapGetters('smtOffiaccount', [
      'smtOffiaccountInfo',
    ]),
  },
  methods: {
    open() {
      this.isShow = true
    },
    handleClose() {
      this.isShow = false
    },
  },
}
</script>

<style lang="scss">
.offiaccount-dialog {
  .el-dialog__header .el-dialog__title {
    color: $--color-text-primary;
  }
  .el-dialog__body {
    padding: 20px 20px 40px;
  }

  .offiaccount-dialog__content {
    text-align: center;
    .offiaccount-dialog__content__title {
      font-size: 20px;
      font-weight: 700;
      color: $--color-text-primary;
    }
    .offiaccount-dialog__content__desc {
      margin: 7px 0 24px;
      font-size: 14px;
      color: $--color-text-secondary;
    }
    .offiaccount-dialog__content__tips {
      font-size: 14px;
      color: $--color-text-primary;
    }
    .offiaccount-dialog__content__img {
      margin: 10px 0 12px;
      display: inline-block;
      width: 200px;
    }
    .offiaccount-dialog__content__alert {
      display: flex;
      box-sizing: border-box;
      margin-left: 60px;
      margin-bottom: 20px;
      padding: 7px 13px;
      width: 400px;
      font-size: 12px;
      color: $--tips-color;
      border-radius: 4px;
      background-color: $--tips-background-color;
      >span {
        flex-shrink: 0;
        display: block;
        width: 36px;
      }
      >p {
        flex: 1;
        text-align: left;
      }
    }
    .offiaccount-dialog__content__time {
      line-height: 20px;
      font-size: 12px;
      color: $--color-text-placeholder;
    }
  }
}
</style>
